import { useQuery, useLazyQuery } from "@apollo/client";
import { GET_LAST_WORKER_TIMELOG } from "../../graphql/checkin.graphql";
import { GET_LINE_JOB_BY_ID } from "../../graphql/jobs.graphql";

import { toast } from "react-toastify";
import { LIST_ALL_POSITIONS } from "../../graphql/workers.graphql";
import { getOptions } from "../../utils/array-utils";
import { useTranslation } from "next-i18next";

const useChangeCheck = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [getLastTimelog] = useLazyQuery(GET_LAST_WORKER_TIMELOG, {
    fetchPolicy: "network-only",
  });

  const [getJobData] = useLazyQuery(GET_LINE_JOB_BY_ID, {
    fetchPolicy: "network-only",
  });

  const {
    data: positionsRaw,
    loading: loadingPositions,
    error: positionsError,
  } = useQuery(LIST_ALL_POSITIONS);

  const positionsOptions = getOptions(
    "comment",
    positionsRaw?.position,
    loadingPositions,
    positionsError,
    ["comment_es", "is_misc", "is_standard", "code", "base_rate"]
  ).map((p) => ({
    ...p,
    label: language == "es" && p.comment_es ? p.comment_es : p.label,
  }));

  const onChangeCheck = async (
    jobData = {},
    dataWorker,
    setFieldValue,
    setTimelog
  ) => {
    if (!dataWorker || !jobData?.id) {
      return "waiting";
    }

    const jobResponse = await getJobData({
      variables: {
        id: jobData?.id,
      },
    });

    const job = jobResponse?.data?.line_job_by_pk;

    if(!job?.id){
      return "waiting";
    }


    if (job.state !== "STARTED") {
      toast.error(t("views.checkin.form.jobNotStarted"));
      return "waiting";
    }

    if (!dataWorker.id) {
      toast.error(t("views.checkin.form.noWorkerExist"));
      return "waiting";
    }

    if (dataWorker.users?.[0]?.id === job.leader_id) {
      toast.error(t("views.checkin.form.leaderUnable"));
      return "waiting";
    }

    const response = await getLastTimelog({
      variables: {
        where: {
          deleted_at: { _is_null: true },
          worker_id: { _eq: dataWorker?.id },
        },
      },
    });

    const log = response?.data?.timelog[0];

    setTimelog(log);

    if (
      !log ||
      (log?.line_job_id === job.id && log?.stop_type  ) ||
      (log?.line_job_id !== job.id)
    ) {
      try {

        const locationNotAllowForWorker =
          dataWorker.agency?.locations?.findIndex(
            (location) => location.location.id === job.line.location.id
          ) === -1;

        const isWorkerWithoutPosition = !dataWorker?.position_id;

        if (isWorkerWithoutPosition) {
          toast.error(t("views.checkin.form.workerWithoutPosition"));
          return "waiting";
        }

        if (locationNotAllowForWorker) {
          toast.error(t("views.checkin.form.locationNotAllowForWorker"));
          return "waiting";
        }

        const positions = positionsOptions.filter(
          (p) => (job?.line?.is_misc && p.is_misc) || !job?.line?.is_misc
        );

        const position = !!dataWorker?.position_id
          ? positions.find(
              (pos) =>
                (pos.is_standard || pos.is_misc) &&
                pos.value === dataWorker?.position_id &&
                pos.code !== "LINE_LEADER"
            )
          : "";

        setFieldValue("position", position || "");

        return "checkin";
      } catch (e) {
        console.log(e);
        return "waiting";
      }
    }
    if (log && log?.line_job_id === job.id && log?.stop_type !== "HARD STOP") {
      return "checkout";
    }
    toast.error(t("views.checkin.form.pleaseContactSupport"));
    return "waiting";
  };

  return onChangeCheck;
};

export { useChangeCheck };
